module.exports = __webpack_public_path__ + "static/media/1-体态管理.5b8f126b.png";